import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldString from "../../fields3/generic/string/string"
import FieldProject from "../../fields3/generic/entity/project/project";

const baseConfig = [
    { fieldId: 'name',      label: 'Name',      type: FieldType.STRING,},
    { fieldId: 'projectId', label: 'Project',   type: FieldType.PROJECT },
]

export default class MeetingFields extends FieldsCollection {

    // Quick access
    get name()      : FieldString { return this.get('name') as FieldString }
    get projectId() : FieldProject { return this.get('projectId') as FieldProject }

    constructor() {
        const fieldsConfig = baseConfig
        // we can modify base config with params in constructor if needed

        super(fieldsConfig, EntityType.MEETING)
    }
}